export const LANDING_PAGE_PATH_NAME = '/';
export const CART_PAGE_PATH_NAME = '/cart';
export const ORDER_PAGE_PATH_NAME = '/order';
